import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(token ? "" : "This reset link is missing its token.");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md card-shadow-soft" data-testid="reset-card">
        <CardHeader><CardTitle className="text-2xl" style={{ fontFamily: "Outfit" }}>Choose a new password</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label>New password (min 8 characters)</Label>
              <Input type="password" data-testid="reset-password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={8} required disabled={!token} className="min-h-[44px]" />
            </div>
            <div className="space-y-1.5">
              <Label>Confirm password</Label>
              <Input type="password" data-testid="reset-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required disabled={!token} className="min-h-[44px]" />
            </div>
            {error && <div data-testid="reset-error" className="text-sm text-destructive bg-destructive/10 p-2.5 rounded-md">{error}</div>}
            <Button type="submit" data-testid="reset-submit" className="w-full min-h-[44px]" disabled={busy || !token}>{busy ? "Saving…" : "Set new password"}</Button>
            <Button type="button" variant="outline" className="w-full min-h-[44px]" data-testid="reset-back-login" onClick={() => nav("/login")}>Back to sign in</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
